export interface PercentileBadge {
  /** Short badge text, e.g. "Top 12%" or "#4 of 12". */
  text: string;
  /** Optional tooltip, e.g. "You beat 88% of players". */
  title?: string;
}

// Below this many players a percentile is noise, so we show an honest rank
// instead ("#4 of 12") — it reads truthfully at any field size.
const MIN_FOR_PERCENTILE = 20;

/**
 * A per-puzzle standing badge from the leaderboard's rank + player count.
 * `rank` is 1-based (1 = best). Returns null when there's nothing meaningful
 * to show (no ranked play, or the player is the only entrant).
 */
export function percentileLabel(
  rank: number | null | undefined,
  total: number,
): PercentileBadge | null {
  if (rank == null || total <= 1) return null;
  if (total < MIN_FOR_PERCENTILE) return { text: `#${rank} of ${total}` };
  const top = Math.max(1, Math.round((rank / total) * 100));
  const beat = Math.round(((total - rank) / (total - 1)) * 100);
  return { text: `Top ${top}%`, title: `You beat ${beat}% of players` };
}
